import React, { Component } from 'react';
import { Button } from '@mui/material';
// import { Emoji } from 'emoji-mart'
import ccs from 'countrycitystatejson';
import normalize  from 'us-states-normalize'
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';
import { APIURL } from '../../../../config'

const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        color: '#3FA7D6',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#3FA7D6',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'lightblue',
        },
        '&:hover fieldset': {
          borderColor: '#3FA7D6',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#3FA7D6',
        },
      },
    },
  })(TextField);

class PersonalDetails extends Component {
    
    state = {
        currentAddress: "",
        addressSuggestions: [],
    }
    
    createPhoneNumberList = () => {
        let code = ccs.getCountryByShort('US')
        let phoneList = this.props.phnNumList.map((phn, indx)=>(
            <div key={phn.phnId}>
            <div className="d-flex flex-row justify-content-between w-75">
                <h5>Phone Line {++indx}</h5><i className="fas fa-trash" id={"del"+phn.phnId} onClick={(event) => this.props.deletePhoneNumber(event)} style={{ fontSize: "1.5rem", cursor: "pointer" }}></i>
            </div>
            <div>
                {/* <Form.Group as={Col} controlId={"country_code"}>
                    <Form.Label>COUNTRY CODE</Form.Label>
                    <Form.Control value={phn.country_code} onChange={(event) => this.props.handlePhoneListChange(phn.phnId,event)} />
                </Form.Group> */}
                {/* <Form.Group as={Col} controlId="country_code">
                    <Form.Label>COUNTRY CODE</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                    <div className="d-flex flex-row justify-content-around" style={{width: '14.5rem',height:'2.4rem',border:'1px solid #D6D6D6',borderRadius:'5px', textAlign:'center'}}>
                        <div style={{marginLeft: 0, marginTop:5}}><Emoji emoji=':flag-us:' size={26}/></div> <div style={{marginRight: 5, marginTop:5}}>United States (+1)</div>
                    </div>
                </Form.Group> */}
                <CssTextField
                  style={{width: '30%'}}
                    className={`mx-1 my-3`}
                    label="COUNTRY CODE"
                    value={`${code.emoji} ${code.name}(${code.phone})`}
                    // onChange={props.formChangeHandler} 
                    variant="outlined"
                    id="country_code"
                />
                {/* <Form.Group as={Col} controlId={"phone"}>
                    <Form.Label>PHONE</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                    <Form.Control value={phn.phone} onChange={(event) => this.props.handlePhoneListChange(phn.phnId,event)} />
                </Form.Group> */}
                <CssTextField
                style={{width: '45%'}}
                    className={`mx-1 my-3`}
                    label="PHONE *"
                    value={phn.phone}
                    onChange={(event)=>{this.props.handlePhoneListChange(phn.phnId,event)}} 
                    variant="outlined"
                    id="phone"
                />
            </div>
        </div>
        ));
        return phoneList
    }

    handleAddressSuggestions = async(value) => {
        let newAddressSuggestions = await axios.get(APIURL + '/maps', { params: { input: value } })
        this.setState({addressSuggestions: newAddressSuggestions.data.predictions, currentAddress: value === undefined  ? '' : value})
    }

    handleAddressSelect = async(value) => {
        let newAddressDetails = await axios.get(APIURL + '/maps/details', { params: { place_id: value.place_id } })
        this.props.formChangeHandler({
            target: {
                id: 'address_maps'
            },
            value: newAddressDetails.data
        })
    }

    render() {
        let phoneList = this.createPhoneNumberList()
        // let states = this.props.states.map((state, indx) => <option key={indx}>{state}</option>)
        let states = ccs.getStatesByShort('US').filter( state => { return state.length > 2 });
        let cities = this.props.formVals.state ? ccs.getCities('US', normalize(this.props.formVals.state, { returnType: 'name' })) : [];
        states=states.map((state, indx) =>{return {title:normalize(state),value:state}})
        cities=cities.map((city, indx) => {return {value:city, title: city}})
        
        return (
            <div>
                {/* <Form.Row>
                    <Form.Group as={Col} className="d-none" controlId="employee_id">
                        <Form.Label>EMPLOYEE ID</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                        <Form.Control type="text" onChange={(event) => this.props.formChangeHandler(event)}/>
                    </Form.Group>
                </Form.Row> */}
                <div>
                    {/* <Form.Group as={Col} controlId="first_name">
                        <Form.Label>FIRST NAME</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                        <Form.Control type="text" value={this.props.formVals.first_name}onChange={(event) => this.props.formChangeHandler(event)}/>
                    </Form.Group> */}
                    <CssTextField
                    style={{width: '36%'}}
                        className={`mx-2 my-3`}
                        label="FIRST NAME *"
                        value={this.props.formVals.first_name}
                        onChange={this.props.formChangeHandler} 
                        variant="outlined"
                        id="first_name"
                    />

                    {/* <Form.Group as={Col} controlId="last_name">
                        <Form.Label>LAST NAME</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                        <Form.Control type="text" value={this.props.formVals.last_name}onChange={(event) => this.props.formChangeHandler(event)}/>
                    </Form.Group> */}
                     <CssTextField
                    style={{width: '36%'}}
                        className={`mx-1 my-3`}
                        label="LAST NAME *"
                        value={this.props.formVals.last_name}
                        onChange={this.props.formChangeHandler} 
                        variant="outlined"
                        id="last_name"
                    />
                </div>

                <div>
                    
                    <Autocomplete
                        autoSelect
                        selectOnFocus
                        disablePortal
                        id="address_maps"
                        sx={{ width: 436 }}
                        popupIcon={null}
                        options={this.state.addressSuggestions}
                        getOptionLabel={(option) => option.description}
                        onChange={(event, value, reason) => {
                            if(reason === 'selectOption'){
                                this.handleAddressSelect(value)
                            }
                        }}
                        onInputChange={(event, value, reason) => {
                            if(reason === 'input'){
                                this.handleAddressSuggestions(value)
                            }
                        }}
                        renderInput={(params) => <CssTextField {...params} className={`mx-2 my-3 w-100`} label="ADDRESS *" variant="outlined" id="address_maps_TextField"/> }
                    />
                </div>

                {/* <Form.Group controlId="address1">
                    <Form.Label>ADDRESS LINE 1</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                    <Form.Control value={this.props.formVals.address1}onChange={(event) => this.props.formChangeHandler(event)}/>
                </Form.Group> */}
                 {/*
                 <CssTextField
                    // style={{width: '45%'}}
                        disabled    
                        className={`mx-1 my-3 w-75`}
                        label="ADDRESS LINE 1"
                        value={this.props.formVals.address1}
                        onChange={this.props.formChangeHandler} 
                        variant="outlined"
                        id="address1"
                />
                */}

                {/* <Form.Group controlId="address2">
                    <Form.Label>ADDRESS LINE 2</Form.Label>
                    <Form.Control value={this.props.formVals.address2} onChange={(event) => this.props.formChangeHandler(event)}/>
                </Form.Group> */}
                    {/*
                    <CssTextField
                    // style={{width: '45%'}}
                        className={`mx-1 my-3 w-75`}
                        label="ADDRESS LINE 2"
                        value={this.props.formVals.address2}
                        onChange={this.props.formChangeHandler} 
                        variant="outlined"
                        id="address2"
                    />
                    */}
                <div>
                    {/* <Form.Group as={Col} controlId="city">
                        <Form.Label>CITY</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                        <Form.Control value={this.props.formVals.city} onChange={(event) => this.props.formChangeHandler(event)}/>
                    </Form.Group> */}

                    {/* <Form.Group as={Col} controlId="state">
                        <Form.Label>STATE</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                        <Form.Control value={this.props.formVals.state} as="select" onChange={(event) => this.props.formChangeHandler(event)}>
                            <option>Select State</option>
                            {states}
                        </Form.Control>
                    </Form.Group> */}
                    {/*
                    <CssTextField
                    disabled
                    id="state"
                    variant="outlined"
                    popupIcon={null}
                    className={`mx-2 my-3`}
                    disableClearable={true}
                    style={{ width: '25%' }}
                    />
                    */}
                    {/* <Form.Group as={Col} controlId="city">
                        <Form.Label>CITY</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                        <Form.Control value={this.props.formVals.city} as="select" onChange={(event) => this.props.formChangeHandler(event)}>
                            <option>Select City</option>
                            {cities}
                        </Form.Control>
                    </Form.Group> */}
                {/*
                <CssTextField
                    disabled
                    id="city"
                    variant="outlined"
                    popupIcon={null}
                    className={`mx-2 my-3`}
                    style={{ width: '46%' }}
                />
                */}
                </div>

                {/* <Form.Group controlId="zip">
                    <Form.Label>ZIP</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                    <Form.Control value={this.props.formVals.zip} onChange={(event) => this.props.formChangeHandler(event)}/>
                </Form.Group> */}
                 {/*
                 <CssTextField
                    // style={{width: '45%'}}
                    disabled
                    className={`mx-1 my-3 w-75`}
                    label="ZIP CODE"
                    value={this.props.formVals.zip}
                    onChange={this.props.formChangeHandler} 
                    variant="outlined"
                    id="zip"
                />
                */}

                {/* <Form.Group controlId="email">
                    <Form.Label>Email Address</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                    <Form.Control value={this.props.formVals.email} onChange={(event) => this.props.formChangeHandler(event)} />
                </Form.Group> */}
                 <CssTextField
                    // style={{width: '45%'}}
                    className={`mx-1 my-3 w-75`}
                    label="EMAIL ID"
                    value={this.props.formVals.email}
                    onChange={this.props.formChangeHandler} 
                    variant="outlined"
                    id="email"
                />

                {phoneList}

                <p style={{ cursor: "pointer" }} onClick={() => this.props.addPhoneNumber()}><i className="fas fa-plus-circle"></i> Add Another Phone Number</p>

                <Button className='w-75 ml-2' variant="contained" fullWidth type="button" onClick={() => this.props.onContinue("other_details")}>
                    Continue
                </Button>
            </div>
        )
    }
}

export default PersonalDetails;